export default (function () {

    addEventListener("DOMContentLoaded", (event) => {
        // Get data from global variable set in twig
        const mapPinsData = window.customMapPinsData || [];
        // console.log(mapPinsData);
        const apiKey = "AIzaSyDuKFtXWIyXZaftjcsJF8wnZBZ76TJSnBs";

        let activeMarker = null;
        let mapInstance = null;

        // Get priority color based on types (assip > flex > ado)
        function getPriorityColor(colors) {
            if (!colors || colors.length === 0) return '#FFD700';

            // Priority: yellow (assip) > black (flex) > white (ado)
            if (colors.includes('#FFD700')) return '#FFD700';  // assip
            if (colors.includes('#000000')) return '#000000';  // flex
            if (colors.includes('#FFFFFF')) return '#FFFFFF';  // ado

            return colors[0]; // fallback to first color
        }

        // Close popup function
        function closePopup() {
            const popup = document.getElementById('pin-popup');
            if (!popup) return;

            popup.classList.remove('active');

            // Reset colors to default
            popup.style.backgroundColor = '';
            popup.style.color = '';
            const closeBtn = popup.querySelector('.pin-popup-close');
            if (closeBtn) closeBtn.style.color = '';

            // Reset active marker to normal size
            if (activeMarker) {
                activeMarker.setIcon(activeMarker.normalIcon);
                activeMarker = null;
            }
        }

        const closeBtn = document.getElementById('pin-popup-close-btn');
        if (closeBtn) {
            closeBtn.addEventListener('click', closePopup);
        }

        // Expose closePopup globally for onclick handler
        window.customMapClosePopup = closePopup;

        // Create overlay helper for pixel positioning
        let overlayHelper = null;

        function initOverlayHelper() {
            overlayHelper = new google.maps.OverlayView();
            overlayHelper.draw = function() {};
            overlayHelper.onAdd = function() {};
            overlayHelper.onRemove = function() {};
            overlayHelper.setMap(mapInstance);
        }

        // Show popup at marker position
        function showPopup(marker, pin) {
            closePopup();

            const popup = document.getElementById('pin-popup');
            const mapDiv = document.getElementById('custom-map');

            if (!popup || !mapDiv) return;

            // Wait a bit for overlay to be ready if needed
            if (!overlayHelper || !overlayHelper.getProjection()) {
                setTimeout(() => showPopup(marker, pin), 100);
                return;
            }

            const projection = overlayHelper.getProjection();
            const position = marker.getPosition();
            const point = projection.fromLatLngToContainerPixel(position);

            // Get priority color for popup background
            const pinColor = getPriorityColor(marker.colors);
            popup.style.backgroundColor = pinColor;

            // Adjust text color based on background
            const isLightBackground = pinColor === '#FFD700' || pinColor === '#FFFFFF';
            const textColor = isLightBackground ? '#333333' : '#FFFFFF';
            popup.style.color = textColor;

            // Adjust close button color
            const closeBtn = popup.querySelector('.pin-popup-close');
            if (closeBtn) {
                closeBtn.style.color = '#333333';
            }

            // Update popup content
            const titleElem = document.getElementById('popup-title');
            const textElem = document.getElementById('popup-text');
            const contactElem = document.getElementById('popup-contact');

            if (titleElem) titleElem.textContent = pin.title || '';
            if (textElem) textElem.innerHTML = pin.text || '';

            if (contactElem) {
                if (pin.request_contact) {
                    contactElem.innerHTML = '<em>' + pin.request_contact + '</em>';
                    contactElem.style.display = 'block';
                } else {
                    contactElem.style.display = 'none';
                }
            }

            // Position popup centered on pin (using translate(-50%, -50%) in CSS)
            popup.style.left = point.x + 'px';
            popup.style.top = point.y + 'px';

            // Show popup first to get dimensions
            popup.classList.add('active');

            // Animate marker - use the activeIcon
            marker.setIcon(marker.activeIcon);
            activeMarker = marker;

            // Adjust position if popup goes off screen (accounting for centering)
            setTimeout(() => {
                const popupRect = popup.getBoundingClientRect();
                const mapRect = mapDiv.getBoundingClientRect();

                let newX = point.x;
                let newY = point.y;

                // Calculate how much the centered popup extends beyond its position
                const popupHalfWidth = popupRect.width / 2;
                const popupHalfHeight = popupRect.height / 2;

                // Check if popup extends beyond map bounds and adjust
                if (point.x - popupHalfWidth < 0) {
                    newX = popupHalfWidth + 20;
                }
                if (point.x + popupHalfWidth > mapRect.width) {
                    newX = mapRect.width - popupHalfWidth - 20;
                }
                if (point.y - popupHalfHeight < 0) {
                    newY = popupHalfHeight + 20;
                }
                if (point.y + popupHalfHeight > mapRect.height) {
                    newY = mapRect.height - popupHalfHeight - 20;
                }

                if (newX !== point.x || newY !== point.y) {
                    popup.style.left = newX + 'px';
                    popup.style.top = newY + 'px';
                }
            }, 10);
        }

        // Initialize map when page loads
        function initCustomMap() {
            const mapDiv = document.getElementById('custom-map');
            if (!mapDiv) return;

            // Center the map
            const mapCenter = calculateMapCenter(mapPinsData);

            // Grayscale map styles
            const mapStyles = [
                {
                    "elementType": "geometry",
                    "stylers": [{"color": "#f5f5f5"}]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#f5f5f5"}]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#bdbdbd"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#ffffff"}]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dadada"}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#c9c9c9"}]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels",
                    "stylers": [{"visibility": "on"}]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#333333"}, {"weight": 1.5}]
                }
            ];

            // Create map
            const map = new google.maps.Map(mapDiv, {
                center: mapCenter,
                zoom: 12,
                styles: mapStyles,
                mapTypeControl: false,
                streetViewControl: false
            });

            mapInstance = map;

            // Initialize overlay helper for pixel positioning
            initOverlayHelper();

            // Array to store all markers
            const markers = [];

            mapPinsData.forEach(pin => {
                if (!pin.lat || !pin.lng) return;

                const colors = getMarkerColors(pin.type);
                const markerIcon = createStripedMarkerIcon(colors, 40, 1);

                const marker = new google.maps.Marker({
                    position: {
                        lat: parseFloat(pin.lat),
                        lng: parseFloat(pin.lng)
                    },
                    map: map,
                    title: pin.title,
                    icon: markerIcon
                });

                // Store colors and icon info for later use
                marker.colors = colors;
                marker.normalIcon = markerIcon;
                marker.activeIcon = createStripedMarkerIcon(colors, 40, 1); // Larger for active state

                // Add click listener
                marker.addListener('click', () => {
                    showPopup(marker, pin);
                });

                markers.push(marker);
            });

            // Custom cluster renderer to match your yellow pin style
            const renderer = {
                render: ({ count, position }) => {
                    // Create SVG that looks like your yellow pin
                    const size = 50; // Larger for clusters
                    const svg = `
                        <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="${size/2}" cy="${size/2}" r="${(size/2) - 3}" 
                                    fill="#FFD700" stroke="#ffffff" stroke-width="2"/>
                            <text x="${size/2}" y="${size/2}" 
                                  text-anchor="middle" 
                                  dominant-baseline="middle"
                                  font-family="Arial, sans-serif" 
                                  font-size="16" 
                                  font-weight="bold" 
                                  fill="#333333">
                                ${count}
                            </text>
                        </svg>
                    `;

                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
                            scaledSize: new google.maps.Size(size, size),
                            anchor: new google.maps.Point(size / 2, size / 2)
                        },
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
                    });
                }
            };


            new markerClusterer.MarkerClusterer({
                map,
                markers,
                renderer
            });

            // Close popup when clicking on map
            map.addListener('click', closePopup);

            // Close popup when zooming or moving
            map.addListener('zoom_changed', closePopup);
            map.addListener('dragstart', closePopup);

            // Adjust bounds to show all markers
            if (mapPinsData.length > 1) {
                const bounds = new google.maps.LatLngBounds();
                mapPinsData.forEach(pin => {
                    if (pin.lat && pin.lng) {
                        bounds.extend({
                            lat: parseFloat(pin.lat),
                            lng: parseFloat(pin.lng)
                        });
                    }
                });
                map.fitBounds(bounds, {
                    top: 50,
                    right: 50,
                    bottom: 50,
                    left: 50
                });

                const listener = google.maps.event.addListener(map, "idle", function() {
                    const currentZoom = map.getZoom();
                    if (currentZoom > 14) {
                        map.setZoom(14);
                    }
                    // else if (currentZoom < 9) {
                    //     map.setZoom(9);
                    // }
                    google.maps.event.removeListener(listener);
                });
            }
        }

        // Calculate center point from all pins
        function calculateMapCenter(pins) {
            if (!pins || pins.length === 0) {
                return { lat: 46.5, lng: 6.5 };
            }

            let latSum = 0;
            let lngSum = 0;
            let count = 0;

            pins.forEach(pin => {
                if (pin.lat && pin.lng) {
                    latSum += parseFloat(pin.lat);
                    lngSum += parseFloat(pin.lng);
                    count++;
                }
            });

            if (count === 0) {
                return { lat: 46.5, lng: 6.5 };
            }

            return {
                lat: latSum / count,
                lng: lngSum / count
            };
        }

        function getMarkerColors(type) {
            // Handle both array and single string for backward compatibility
            const types = Array.isArray(type) ? type : [type];

            const colorMap = {
                'assip': '#FFD700',
                'ado': '#FFFFFF',
                'flex': '#000000'
            };

            const colors = types
                .map(t => t ? t.toLowerCase().trim() : null)
                .filter(t => t && colorMap[t])
                .map(t => colorMap[t]);

            // Return default if no valid types
            return colors.length > 0 ? colors : ['#FFD700'];
        }

        // Add this new function to create striped SVG icons
        function createStripedMarkerIcon(colors, size = 40, scale = 1) {
            if (colors.length === 1) {
                // Single color - use standard circle
                const strokeColor = colors[0] === '#FFFFFF' ? '#333333' : '#ffffff';
                // const strokeWeight = colors[0] === '#FFFFFF' ? 3 : 2;
                const strokeWeight = 2;
                return {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: size / 2,
                    fillColor: colors[0],
                    fillOpacity: 1,
                    strokeColor: strokeColor,
                    strokeWeight: strokeWeight
                };
            }

            // Multiple colors - create diagonal striped pattern
            const lineWidth = 4; // Fixed width per stripe
            const patternSize = lineWidth * colors.length; // Pattern size adjusts to number of colors

            // Create pattern with diagonal stripes
            let patternStripes = '';
            colors.forEach((color, index) => {
                const y = index * lineWidth;
                patternStripes += `<rect x="0" y="${y}" width="${patternSize * 2}" height="${lineWidth}" fill="${color}"/>`;
            });

            const svg = `
                <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="stripes-${colors.join('-').replace(/#/g, '')}" 
                                 width="${patternSize}" height="${patternSize}" 
                                 patternUnits="userSpaceOnUse"
                                 patternTransform="rotate(-45)">
                            ${patternStripes}
                        </pattern>
                        <clipPath id="circle-clip-${colors.join('-').replace(/#/g, '')}">
                            <circle cx="${size/2}" cy="${size/2}" r="${(size/2) - 3}"/>
                        </clipPath>
                    </defs>
                    <g clip-path="url(#circle-clip-${colors.join('-').replace(/#/g, '')})">
                        <rect width="${size}" height="${size}" fill="url(#stripes-${colors.join('-').replace(/#/g, '')})"/>
                    </g>
                    <circle cx="${size/2}" cy="${size/2}" r="${(size/2) - 3}" 
                            fill="none" stroke="#222221" stroke-width="2"/>
                </svg>
            `;

            return {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
                scaledSize: new google.maps.Size(size * scale, size * scale),
                anchor: new google.maps.Point((size * scale) / 2, (size * scale) / 2)
            };
        }

        // Expose initCustomMap globally for Google Maps callback
        window.initCustomMap = initCustomMap;

        // Load Google Maps API and initialize
        if (typeof google === 'undefined') {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&callback=initCustomMap`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        } else {
            initCustomMap();
        }
    });
}());